import React from 'react';

const defaultIcon = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 5v14M5 12h14" />
    </svg>
);

const FaqList = ({
    items,
    listClassName,
    itemClassName,
    questionClassName,
    questionTextClassName,
    iconClassName,
    answerClassName,
    icon = defaultIcon
}) => (
    <div className={listClassName}>
        {items.map((faq) => (
            <details key={faq.question} className={itemClassName}>
                <summary className={questionClassName}>
                    {questionTextClassName ? <span className={questionTextClassName}>{faq.question}</span> : faq.question}
                    <span className={iconClassName}>{icon}</span>
                </summary>
                <div className={answerClassName}>
                    <p>{faq.answer}</p>
                </div>
            </details>
        ))}
    </div>
);

export default FaqList;
